var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-timepicker',{class:_vm.cls,attrs:{"value":_vm.value,"placeholder":_vm.holderNm,"input-width":"8em"},on:{"input":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }